import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/akademija/AkademijaClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Navbar.tsx");
